/**
 * Better Auth sign-in route configuration.
 */

import { createFileRoute, redirect } from '@tanstack/react-router'

const SUPPORTED_LOCALES = ['es', 'gl', 'en', 'de', 'fr', 'it', 'nl', 'pt']

export const Route = createFileRoute('/$locale/sign-in')({
  beforeLoad: ({ params }) => {
    // Guard: if $locale is not a real locale (e.g. someone visits /sign-in directly,
    // which TanStack Router matches with $locale='sign-in'), redirect to /es/sign-in.
    if (!SUPPORTED_LOCALES.includes(params.locale)) {
      throw redirect({ to: '/$locale/sign-in', params: { locale: 'en' }, search: { error: undefined } })
    }
  },
  validateSearch: (s: Record<string, unknown>) => {
    // B-new-1327 Bug B1 — a duplicate `error` query key (our own
    // errorCallbackURL plus BetterAuth's appended `?error=<code>`) parses to
    // an ARRAY under TanStack Router's default query parser. The old
    // `typeof === 'string'` guard silently dropped that case, losing the
    // error entirely. Defensively tolerate an array here too, taking the
    // LAST value — BetterAuth's real failure code is appended after any
    // pre-seeded placeholder, so it sorts last.
    const rawError = s.error
    const error =
      typeof rawError === 'string'
        ? rawError
        : Array.isArray(rawError) && typeof rawError[rawError.length - 1] === 'string'
          ? (rawError[rawError.length - 1] as string)
          : undefined
    return {
      ...(error !== undefined ? { error } : {}),
      ...(typeof s.redirect === 'string' ? { redirect: s.redirect } : {}),
    }
  },
})
